import { render, staticRenderFns } from "./ShowGroupData.vue?vue&type=template&id=67ef90dd"
import script from "./ShowGroupData.vue?vue&type=script&lang=js"
export * from "./ShowGroupData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports